// extracted by mini-css-extract-plugin
export var content = "_cz-3";
export var list = "_cz-4";
export var settingsContent = "_cz-7";
export var settingsPanel = "_cz-8";
export var state = "_cz-6";
export var triggerBadge = "_cz-2";
export var triggerButton = "_cz-1";
export var triggerShell = "_cz-0";
export var unreadDot = "_cz-5";